import { render, staticRenderFns } from "./DoubleBounce.vue?vue&type=template&id=54a4c499&scoped=true&"
import script from "./DoubleBounce.vue?vue&type=script&lang=js&"
export * from "./DoubleBounce.vue?vue&type=script&lang=js&"
import style0 from "./DoubleBounce.vue?vue&type=style&index=0&id=54a4c499&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4c499",
  null
  
)

export default component.exports